import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import PrimeVue from "primevue/config";

// Importar CSS necesario para PrimeVue
import "primevue/resources/themes/saga-blue/theme.css"; // Tema opcional
import "primevue/resources/primevue.min.css"; // CSS principal de PrimeVue
import "primeicons/primeicons.css"; // Iconos

import { provideEvents } from "./utils/events";

// Añadir todos los iconos a la biblioteca
library.add(fas, far, fab);
const app = createApp(App);
provideEvents(app); // Proporciona el bus de eventos
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(store).use(router).use(PrimeVue).mount("#app");
